<section class="container routing pt-5">
    <div class="d-flex justify-content-center align-items-center error mt-5">
        <div>
            <img src="./assets/images/error-card.png" alt="error">
            <h1 class="mt-3">{{'payment.payment faild' | translate}}</h1>
            <p class="text-muted">{{'payment.payment again' | translate}}</p>
        </div>
    </div>
</section>